import ConBox from './src/main'
import { addComponent } from '~/utils/helper'

export default addComponent(ConBox)


// WEBPACK FOOTER //
// ./public/con-box/index.js